"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function hasSpecialCharacters() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!text) return new classes_1.ValidationResult(true);
  var isValid = !text.trim().match(/[~!@#$%^&*()\-_+=`{}[\]|\\:;'<>,./?]/gi);
  var message = isValid ? '' : 'Esse campo não deve conter caracteres especiais';
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(hasSpecialCharacters);